export const formPatterns = {
  texto: /^[a-zA-Z0-9-_.,ñÑáéíóúÁÉÍÓÚüÜ?¿!¡$#&"”'%();:+*/ ]*$/,
  textoNombre: /^[a-zA-Z0-9-_:&.ñÑáéíóúÁÉÍÓÚüÜ/+ ]*$/,
  textoExplicacion:
    /^[a-zA-Z0-9-_.,ñÑáéíóúÁÉÍÓÚüÜ?¿!¡$#&"”'%();:+*={}[\]@/ \n\s]*$/,
  peso: /^[0-9.$]*$/,
  email: /^[a-zA-Z0-9._-]*@[a-zA-Z0-9]+([.-]{0,1}[a-zA-Z0-9])*\.[a-zA-Z]{2,4}$/,
  numero: /^[0-9]*$/,
  telefono:
    /^((\+?56([ t|-])?)?[9|6|7]((\d{1}([ t|-])?[0-9]{3})|(\d{2}([ t|-])?[0-9]{2}))([ t|-])?[0-9]{2}([ t|-])?[0-9]{2})$/,
  telefonoFijoMovil: /^[\+]?[(]?(56)?\)?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
  codigoOferta: /^(MP)(\d{2})?(\/)?[0-9]{7,8}$/,
  telefonoFijo: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
}
